import { render, staticRenderFns } from "./letterReservation.vue?vue&type=template&id=e87f6782"
import script from "./letterReservation.vue?vue&type=script&lang=js"
export * from "./letterReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports